import React, {
  useState, useEffect, useRef
} from 'react';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';
import lookup from 'country-code-lookup';
import { Wrapper } from '@googlemaps/react-wrapper';

import { _ } from '_locales';
import images from '_images';
import { colors } from '_styles';
import HOC from '_HOC';
import cts from '_cts';
import apis from '_apis';
import { connect } from 'react-redux';
import { zone as zoneSetup } from '_actions';
import { WaitScreen, Input } from '_components';
import { confirmHandler, getZone } from '../../utils';

/**
 *
 * import styles
 */
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Container = styled.div`
 background-color: #fff;
`;

const SearchInputContainer = styled.div`
  width: calc(100% - 185px);
  float: left;
  margin-top: 3px;
  border-radius: 15px 0 0 15px;

  input {
    border-radius: 15px 0 0 15px;

    &:focus {
      outline: none !important;
      box-shadow: 0 0 2px 2px #51a7e8;
      border-radius: 15px 0 0 15px;
    }
  }

  @media screen and (max-width: 500px) {
    width: 100%;
    border-radius: 15px;
    float: initial;

    input {
      border-radius: 15px;

      &:focus {
        outline: none !important;
        box-shadow: 0 0 2px 2px #51a7e8;
        border-radius: 15px;
      }
    }
  }

  ${(parentWidth < 501) && css`
    width: 100%;
    border-radius: 15px;
    float: initial;

    input {
      border-radius: 15px;

      &:focus {
        outline: none !important;
        box-shadow: 0 0 2px 2px #51a7e8;
        border-radius: 15px;
      }
    }
  `};
`;

const inputStyle = {
  width: '100%',
  border: 'none',
  backgroundColor: '#f3f2f2',
  fontSize: '14px',
  fontFamily: 'Roboto,sans-serif',
  color: '#000',
  fontWeight: '400',
  padding: '23px',
  boxSizing: 'border-box',
  height: 22,
  lineHeight: '15px',
};

const ConfirmInputContainer = styled.div`
  width: 185px;
  border-radius: 0 15px 15px 0;
  margin-top: 3px;
  display: inline-block;

  input {
    border-radius: 0 15px 15px 0;

    &:focus {
      outline: none !important;
      box-shadow: 0 0 2px 2px #51a7e8;
    }
  }

  @media screen and (max-width: 500px) {
    display: none;

    input,
    label {
      display: none;
    }
  }

  ${(parentWidth < 501) && css`
    display: none;

    input,
    label {
      display: none;
    }
  `};
`;

const submitInputStyle = {
  width: '100%',
  border: 'none',
  fontSize: '14px',
  fontFamily: 'Roboto,sans-serif',
  color: '#f3f2f2',
  fontWeight: '500',
  padding: '23px',
  boxSizing: 'border-box',
};

const InputHolder = styled.div`
   width: 100%;
   max-width: 577px;
   position: relative;
   margin: 0 auto;
   padding: 45px 20px;
   box-sizing: border-box;
   background-color: white;

   &.before-search {
    z-index: 1;
   }

   @media screen and (max-width: 500px) {
    padding-top: 30px !important;
   }

  ${(parentWidth < 501) && css`
    padding-top: 30px !important;
  `};
`;

const Label = styled.label`
   font-size: 14px !important;
   font-weight: 400 !important;
   font-family: Roboto,sans-serif !important;
   font-stretch: normal !important;
   font-style: normal !important;
   line-height: 1.36;
   letter-spacing: normal;
   text-align: left;
   color: #0a1514;
   display: block;
   margin-bottom: 11px;

   @media screen and (max-width: 500px) {
    font-size: 20px !important;
    text-align: center !important;
    margin-bottom: 30px !important;
   }

  ${(parentWidth < 501) && css`
    font-size: 20px !important;
    text-align: center !important;
    margin-bottom: 30px !important;
  `};
`;

const MapHolder = styled.div`
   width: 100%;
   height: 440px;
   position: relative;
   padding: 0 20px;
   box-sizing: border-box;
   margin-bottom: 30px;

  &.before-search {
    height: 140px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 0;
    max-width: 577px;
    
    width: 100%;
    top: 0;

    & > #over_lay_map {
      display: none;
    }
  }
`;

const MapContainer = styled.div`
   overflow: hidden;
   height: 100%;
   z-index: 1;
   border-radius: 15px;
`;

const DefaultMarker = styled.div`
   background-image: url(${images.icons.marker});
   background-repeat: no-repeat;
   background-size: 41px;
   background-position: center;
   position: absolute;
   top: 44%;
   left: 50%;
   transform: translate(-50%, -50%);
   z-index: 1;
   width: 40px;
   height: 54px;

   &.before-search {
     display: none;
   }
`;

const ListBtn = styled.button`
   display: inline-block; 
   -moz-appearance: none;
   -webkit-appearance: none;
   background-color: none;
   border: none;
   outline: none;
   font-size: inherit !important;
  font-family: Roboto, sans-serif !important;

   background-color: #fff;
   border-radius: 50%;
   position: absolute;
   color: black !important;
   border: none;
   text-shadow: none !important;
   bottom: 0;
   margin: 20px;
   width: 45px;
   height: 45px !important;
   box-shadow: 0 3px 10px rgba(0,0,0,0.2);
   cursor: pointer;
   padding: 0;

   &:focus {
     outline: none;
   }

  ${(parentWidth < 631) && css`
    right: 7px;
    bottom: 92px;
  `};

  &.before-search {
    display: none;
  }
`;

const InnerListButton = styled.span`
   padding: 15px 0px;
   cursor: pointer;
   display: inline-block;
   position: relative;
   width: 100%;

   ${ListBtn}:focus > & {
       box-shadow: 0 0 2px 2px #51a7e8;
   }

   &:focus {
       outline: none;
   }

  ${(parentWidth < 631) && css`
    padding: 11px 0;
  `};
`;

const CoveredMapStyle = {
  position: 'absolute',
  top: '0px',
  zIndex: '0',
  width: 'calc(100% - 40px)',
  visibility: 'hidden',
  height: '600px',
};

const Button = styled.button`
  font-size: 16px !important;
  font-family: Roboto, sans-serif !important;
  border-radius: 12px;
  margin-right: 15px;
  width: 287px;
  height: 39px;
  flex: 1;
  color: #fff;
  background-color: ${colors.RC_ACTION};
  cursor: pointer;
  border: none;
`;

const H4 = styled.h4`
  flex: 1;
  margin: 0;
  font-weight: 400 !important;
  font-size: 16px !important;
  font-family: Roboto, sans-serif !important;
`;

const ConfirmButtonHolder = styled.div`
 position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #fff;
  padding: 11px;
  box-sizing: border-box;
  border-radius: 15px;
  font-family: Roboto,sans-serif !important;
  font-weight: 400 !important;
  display: flex;
  max-height: 84px;

  ${(parentWidth < 631) && css`
    left: auto;
    transform: inherit;
    box-sizing: border-box;
    width: calc(100% - 120px);
    margin: 4px 20px;

    button {
      font-size: 15px !important;
    }
  `};

  h4 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${(parentWidth < 368) && css`
    h4 {
      display: none;
    }

    button {
      margin-right: 0px !important;  
    }
  `};

  &.before-search {
    display: none;
  }
`;

const ErrorText = styled.p`
  font-weight: 400 !important;
  font-size: 14px !important;
  font-family: Roboto, sans-serif !important;
  color: #E72929;
`;
// End styles

const ZoneSetupMap = ({
  plugin, zone, config, setCoordinate, props
}) => {
  /* Define the states from redux */
  const { projectId } = plugin;
  const { coordinate, prompts, countryName } = zone;
  const { districtId, exampleAddress, webappConfig } = config;
  const { address_message = null } = webappConfig;
  const prevRoute = props.location.state;
  const { main_color = '' } = config.templateColour ? JSON.parse(config.templateColour) : {};

  // get the iso code by country name
  const countryIsoCode = lookup.byCountry(countryName).iso2;

  /* Hooks */
  const overLayMapRef = useRef(null);
  const coveredMapRef = useRef(null);
  const googleInputRef = useRef(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState('');
  const [latLng, setLatLng] = useState({ lat: '', lng: '' });

  const history = useHistory();

  /* Go to the list search page */
  const ListClickHandler = () => history.push('/zone-setup/list');

  useEffect(() => {
    setError(false);
  }, [selectedAddress]);

  useEffect(() => {
    if (
      selectedAddress
      && selectedAddress === googleInputRef.current.value
    ) {
      setSelectedAddress('');
      googleInputRef.current.value = '';
    }
  }, [latLng, googleInputRef]);

  const showPosition = async () => {
    try {
      const { data, status } = await cts('get', apis.getGoogleAddress(latLng.lat, latLng.lng));

      if (
        !data.status
        && status !== 200
      ) throw new Error('Error to getting google address by gps button.');

      return Promise.resolve(data.results[0].formatted_address);
    } catch (e) {
      return Promise.reject(e.message);
    }
  };

  /* Confirm the zone */
  const ConfirmZone = async () => {
    try {
      setLoading(true);
      const changedAddress = { adr: '' };

      const zoneObject = await getZone(
        projectId, districtId, latLng.lat || coordinate.lat, latLng.lng || coordinate.lng
      );

      if (
        latLng.lat
        || latLng.lng
      ) setCoordinate({ lat: latLng.lat, lng: latLng.lng });

      if (
        !zoneObject
        || !zoneObject.length
      ) alert('Sorry, there is no services here!');

      if (!selectedAddress.length) {
        const changedAdrByMap = await showPosition();
        changedAddress.adr = changedAdrByMap;
      }

      // REVIEW COMMENT: This is not a good way, let's talk about it
      const confirmStatus = confirmHandler(
        history, 'map', zoneObject, (changedAddress.adr) ? changedAddress.adr : selectedAddress, prevRoute
      );

      confirmStatus.catch((rej) => console.warn('There was a problem in confirm the selected zone, in ConfirmZone function at ZoneSetupMap component.', rej));

      setLoading(false);
    } catch ({ message }) {
      setError(true);
      setLoading(false);
    }
  };

  const maploadCallback = () => {
    try {
      if (window?.google) {
        const map = new window.google.maps.Map(overLayMapRef.current, {
          center: (latLng.lat || latLng.lng) ? latLng : coordinate,
          zoom: 17,
          options: {
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
          }
        });

        const constMap = new window.google.maps.Map(coveredMapRef.current, {
          center: coordinate,
          zoom: 9,
          options: {
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
          }
        });

        const options = {
          componentRestrictions: { country: countryIsoCode },
          fields: ['formatted_address', 'geometry', 'icon', 'name'],
          origin: constMap.getCenter(),
          strictBounds: true,
        };

        window.autocomplete = new window.google.maps.places.Autocomplete(
          googleInputRef.current, options
        );

        window.autocomplete.bindTo('bounds', constMap);

        window.autocomplete.setFields(
          ['address_components', 'geometry', 'icon', 'name']
        );

        window.autocomplete.setTypes([]); /* set type all [] [address,establishment,geocode] */

        const onPlaceChanged = () => {
          const place = window.autocomplete.getPlace();

          map.fitBounds(place.geometry.viewport);

          setIsSearched(true);
          setSelectedAddress(googleInputRef.current.value);
          return undefined;
        };

        window.autocomplete.addListener('place_changed', onPlaceChanged);

        window.google.maps.event.addListener(map, 'center_changed', () => {
          const center = map.getCenter();
          const latitude = center.lat();
          const longitude = center.lng();
          setLatLng({ lat: latitude, lng: longitude });
        });

        return map;
      }

      return undefined;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const render = () => (
    <Container>
      <InputHolder className={!isSearched && 'before-search'}>
        <Label htmlFor="g-addr-search1">{address_message || _('zone.find_out_your_waste_and_recycling_pickup_schedule')}</Label>
        <SearchInputContainer>
          <input
            type="text"
            id="g-addr-search1"
            ref={googleInputRef}
            placeholder={`${_('zone.street_name')} ${exampleAddress ? `(e.g. ${exampleAddress})` : ''}`}
            style={inputStyle}
          />
        </SearchInputContainer>
        <ConfirmInputContainer>
          <label htmlFor="submit-my-schedule" style={{ display: 'none' }}>{_('zone.show_my_schedule')}</label>
          <Input
            type="submit"
            id="submit-my-schedule"
            style={{
              ...submitInputStyle,
              backgroundColor: (main_color ? `#${main_color}` : colors.RC_ACTION)
            }}
            value={_('zone.show_my_schedule')}
            ariaLabel={_('zone.show_my_schedule')}
          />
        </ConfirmInputContainer>
        {error && <ErrorText>{_('zone.please_select_a_valid_zone')}</ErrorText>}
      </InputHolder>

      {/* Error */}

      <MapHolder className={!isSearched && 'before-search'}>
        <MapContainer id="over_lay_map" ref={overLayMapRef} />
        <DefaultMarker className={!isSearched && 'before-search'} />
        {!!prompts[0].zoneSelectOptions.list && (
          <ListBtn className={!isSearched && 'before-search'} tabIndex="0" onClick={ListClickHandler} style={{ zIndex: 1 }} aria-label="go to the list options">
            <InnerListButton tabIndex="-1">{_('zone.list')}</InnerListButton>
          </ListBtn>
        )}

        <ConfirmButtonHolder className={!isSearched && 'before-search'}>
          <Button onClick={ConfirmZone} aria-label="confirm the location">
            {_('zone.confirm_location')}
          </Button>
          <H4>
            {' '}
            {_('zone.or_move_the_map_to_adjust_the_location')}
          </H4>
        </ConfirmButtonHolder>
      </MapHolder>
      <MapContainer ref={coveredMapRef} style={CoveredMapStyle} />

      {
        loading && (<WaitScreen />)
      }
    </Container>
  );

  return (
    <Wrapper
      apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
      libraries={['places']}
      callback={maploadCallback}
      render={render}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  setCoordinate: (coordinate) => dispatch(zoneSetup.setCoordinate(coordinate)),
});

export default HOC(connect(null, mapDispatchToProps)(ZoneSetupMap));
